
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ShoppingCart } from "lucide-react";
import { SchoolUnit } from "../Layouts/SchoolUnit";
import { getSecondSemesterAdjustmentDeadline } from "@/lib/orderCycle";
import { formatDate } from "@/lib/formatters";

const ClientSelector = ({ isScheduled, cycleYear }: { isScheduled: boolean; cycleYear?: number }) => {
  const adjustmentDeadline = formatDate(getSecondSemesterAdjustmentDeadline(cycleYear ?? new Date().getFullYear()));
  return (
    <Card className="shadow-card hover:shadow-lg  transition-all duration-200 mb-8">
      <CardHeader className="gradient-primary text-white rounded-lg">
        <div className="flex items-center gap-2">
          <ShoppingCart className="h-6 w-6" />
          <h2 className="font-semibold tracking-tight flex items-center gap-2 text-xl sm:text-2xl">
            Portal de Pedidos
          </h2>
        </div>
        <div className="text-white text-sm space-y-3">
          <div className="space-y-2">
            <p>Prezado(a) cliente,</p>
            {isScheduled ? (
              <>
                <p>Seu pedido referente à Plataforma AZ para o 2º semestre já está programado!</p>
                <p>Verifique as quantidades, faça os ajustes necessários e finalize o pedido até o dia {adjustmentDeadline}. Após essa data, os pedidos não confirmados serão processados automaticamente.</p>
              </>
            ) : (
              <>
                <p>O ciclo de pedidos 2027 está aberto!</p>
                <p>Realize seu pedido até 31/10/2026 e garanta frete grátis.</p>
                <p>Fique atento aos prazos e condições previstos no Playbook 2027.</p>
                <p>Em caso de dúvidas, nossos canais de atendimento estão à disposição para ajudar.</p>
              </>
            )}
            <p>
              <br />
              Ajuda Conexia: <a href="https://ajuda.conexia.com.br/hc/pt-br/requests/new" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">
                https://ajuda.conexia.com.br/hc/pt-br/requests/new
              </a>
            </p>
            <p>
              WhatsApp: <a href="https://api.whatsapp.com/send/?phone=5508003458000&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">0800-345-8000</a>
            </p>
          </div>
        </div>
      </CardHeader>
      {/* <CardContent className="p-4">
        <SchoolUnit />
      </CardContent> */}
    </Card>
  );
};

export default ClientSelector;
